const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minWidth: 150,
        margin: '0px 2% 24px',
        padding: 24,
        textAlign: 'center',
        cursor: 'pointer',
        boxShadow: '0 7px 25px rgba(0, 0, 0, 0.12)',
    },
    date: {
        width: '70%',
        height: 18,
        fontSize: 16,
        paddingBottom: 30,
    },
    title: {
        width: '100%',
        fontSize: 16,
        height: 18,
    },
});

export default styles;
